import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { ID_SORTED_SCALES } from 'constants/scales';
import './styles.scss';
import MotivatorIcon from './MotivatorIcon';

const PersonalizedTip = ({
    tipText, tipScale, textColor, isShowToolTip
}) => {
    const motivatorText = ID_SORTED_SCALES[tipScale - 1];
    return (
        <div className={ `personalized-tip-container ${ isShowToolTip ? 'normal' : 'shrunken' }` }>
            <div className='tip-content'>
                <h3>{i18n.t('engagement.this_is_a_personalized_tip')}</h3>
                <div className='tip-content-header'>
                    <MotivatorIcon textColor={ textColor } motivatorText={ motivatorText } />
                    <h4 style={ { color: textColor } }>{i18n.t(`motivator.scale_${ motivatorText }`)}</h4>
                </div>
                <p>{tipText}</p>
            </div>
        </div>
    );
};

PersonalizedTip.propTypes = {
    tipText: PropTypes.string,
    tipScale: PropTypes.number,
    textColor: PropTypes.string,
    isShowToolTip: PropTypes.bool
};

export default PersonalizedTip;
